"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CountryState;
var _react = _interopRequireWildcard(require("react"));
var _DotLoader = _interopRequireDefault(require("react-spinners/DotLoader"));
var _reactBootstrap = require("react-bootstrap");
var _react2 = require("@emotion/react");
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _axios = _interopRequireDefault(require("axios"));
var _usersession = require("usersession");
var _templateObject;
/*
    06/14/2020 - Suhas

    This is a slider to show state in Rate-Quote slider.

    Following are the changes done from its original implementation:
    1. County is separated from the CountryState form
    2. City selection has also been removed
    
*/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop, {
  behavior: "smooth"
});
// General scroll to element function

function CountryState(props) {
  const userSession = new _usersession.UserSession();
  const [loading, setLoading] = (0, _react.useState)(false);
  const [propAddressState, setPropAddressState] = (0, _react.useState)("");
  const [statesOptions, setStatesOptions] = (0, _react.useState)("");
  const dispatch = (0, _reactRedux.useDispatch)();
  const countryStateRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.countryState);
  const stateCountyRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.stateCounty);
  const myRefState = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    //This function scroll the slider into view
    !localStorage.getItem("doNotScroll") && scrollToRef(myRefState);
    document.getElementById("next-button").disabled = false;
  }, []);
  const override = (0, _react2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n    margin: 0 auto;\n  "])));
  (0, _react.useEffect)(() => {
    let zipCode = userSession.getPropertyZipCode();
    let propertyState = userSession.getPropertyState();
    let stateList = JSON.parse(userSession.getStateList());

    // every time you select a new state clear out county
    setPropAddressState(countryStateRedux);
    userSession.setPropertyState(countryStateRedux);
    if (propAddressState.length > 0) {
      dispatch((0, _actions.ShowButtons)(true));
      // ShowButtons(true);
    }
    setStatesOptions(stateList.map((item, index) => /*#__PURE__*/_react.default.createElement("option", {
      key: index,
      value: item.code
    }, item.name)));
    if (zipCode.length < 5) {
      // if we already loaded property state then get it from the user session
      if (propertyState.length > 0) {
        setPropAddressState(propertyState);
        dispatch((0, _actions.countryStateUpdate)(propertyState));
        // countryStateUpdate(propertyState);
      }
      // else set it to the first item on the list
      else {
        // setPropAddressState(response.data[0].code);
        // userSession.setPropertyState(response.data[0].code);
        // dispatch(countryStateUpdate(response.data[0].code));
      }
    }
    if (zipCode.length === 5) {
      setLoading(true);
      _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipCode, "", {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        setPropAddressState(response.data.state);
        userSession.setPropertyState(response.data.state);
        dispatch((0, _actions.countryStateUpdate)(response.data.state));
        // countryStateUpdate(response.data.state);

        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function clearStateCounty() {
    // every time you select a new state clear out county
    if (stateCountyRedux.length > 0) {
      dispatch((0, _actions.stateCountyUpdate)(""));
      // stateCountyUpdate("");
      userSession.setPropertyCounty("");
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex justify-content-center pt-1"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Your State")), loading ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sweet-loading"
  }, /*#__PURE__*/_react.default.createElement(_DotLoader.default, {
    css: override,
    size: 20,
    color: "#0069d9",
    loading: loading
  }))) : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Col,
    lg: 4,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    className: "sr-only"
  }, "State"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    ref: myRefState,
    value: propAddressState,
    placeholder: "Property State",
    onChange: e => {
      setPropAddressState(e.target.value);
      clearStateCounty();
      dispatch((0, _actions.countryStateUpdate)(e.target.value));
      // countryStateUpdate(e.target.value);
    }
  }, statesOptions))));
}